module.exports = __webpack_public_path__ + "static/media/LogoPlayMachines2.c5fc02b2.png";